// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/international-payment/international-payment.component.scss
// module id = 710
// module chunks = 0